import formHelper from '@/libs/forms';
import inquiryHelper from '@/components/inquiry/libs/helper';


const hint = `
  By clicking Sign Up, you agree to our
  <a href="https://www.anchorloans.com/privacy-policy" target="_blank">Privacy Policy</a>.
`;

export default {
  schema: submitHandler => ({
    fields: [
      formHelper.simpleInput('text', 'First Name', null, 'firstName', true, 6),
      formHelper.simpleInput('text', 'Last Name', null, 'lastName', true, 6),
      formHelper.email('Email', 'userEmail', null, true, 6),
      formHelper.phone('Cell Phone', 'phoneNumber', true, 6),
      formHelper.password('Password', 'password', 8, 12),
    ].concat(
      inquiryHelper.referralFields(
        'col-sm-12',
        'col-sm-12',
        'col-sm-12',
      ),
      formHelper.checkbox(
        'I want to receive e-mail notifications from Anchor Marketing',
        'optIn', 12, false, 'col-sm-12',
      ),
      formHelper.submitBtn('Create an account', hint, submitHandler, 'ml-2 auth__submit-button'),
    ),
  }),
  options: formHelper.options('registration-', true),
};



// WEBPACK FOOTER //
// ./src/components/auth/registration/schema.js